import { ClaudeSchema } from '../../../../api/connectors/schemas/claude.schema';

export const connectorModalTitles = {
  CLOUDFLARE: 'Cloudflare',
  CLAUDE: ClaudeSchema.name,
  GEMINI: 'Google Gemini Connector',
  GOOGLEWORKSPACE: 'Connect to Google Workspace',
  GSC: 'Google Cloud Security Command Center',
  LANGFUSE: 'AI Langfuse Connector',
  SOPHOS: 'SOPHOS ENDPOINT',
} as const;
